import Vue from 'vue';
import Router from 'vue-router';
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '',
      redirect: '/Base/Home'   //重定向到首页
    },
    {
      path: '/login/:linkType?',
      name: 'login',
      component: () => import('@/pages/login/login'),
      meta: {
        requireAuth: false,//不需要做登录状态验证
      }
    },
    {
      path: '/perfectInfo',
      name: 'perfectInfo',
      meta: {
        requireAuth: false,//不需要做登录状态验证
      },
      component: () => import('@/pages/login/perfect-info'),
    },
    {
      path: '/dataView',
      name: 'dataView',
      component: () => import('@/pages/data-view/data-view'),
    },
    {
      path: '/LoginOut',
      name: 'LoginOut',
      component: () => import('@/pages/login/login-out'),
    },
    {
      path: '/OuterCondition/:type/:id/:name',
      name: 'OuterCondition',
      component: () => import('@/pages/report-form/report-form-outer-conditions')
    },
    {
      path: "/ChildrenReportFormManage",
      name: "ChildrenReportFormManage",
      component: () => import('@/pages/report-form/children-report-form-manage')
    },
    {
      path: '/Base',
      name: 'Base',
      component: () => import('@/pages/master'),
      children: [
        {
          path: 'Home',
          name: 'Home',
          component: () => import('@/pages/home/home')
        },
        {
          path: 'Organize',
          name: 'Organize',
          component: () => import('@/pages/organize/organize'),
          meta: {
            requireAuth: false,//不需要做登录状态验证
          }
        },
        {
          path: 'CompanyInfo',
          name: 'CompanyInfo',
          component: () => import('@/pages/company-info/company-info'),
        },
        {
          path: 'TaskManage',
          name: 'TaskManage',
          component: () => import('@/pages/task/task-manage'),
        },
        {
          path: 'Personnel',
          name: 'Personnel',
          component: () => import('@/pages/personnel/personnel'),
        },
        {
          path: 'JobManage',
          name: 'JobManage',
          component: () => import('@/pages/job/job-manage'),
        },
        {
          path: 'Project',
          name: 'Project',
          component: () => import('@/pages/project/project'),
        },
        {
          path: 'Supplier',
          name: 'Supplier',
          component: () => import('@/pages/supplier/supplier'),
        },
        {
          path: 'WorkStructure',
          name: 'WorkStructure',
          component: () => import('@/pages/standing-book/work-structure'),
        },
        {
          path: 'BillOfQuantities',
          name: 'BillOfQuantities',
          component: () => import('@/pages/standing-book/bill-of-quantities'),
        },
        {
          path: 'ZeroAccount',
          name: 'ZeroAccount',
          component: () => import('@/pages/standing-book/zero-account'),
        },
        {
          path: 'ResourceLedger',
          name: 'ResourceLedger',
          component: () => import('@/pages/standing-book/resource-ledger'),
        },
        {
          path: 'ConcreteProportion',
          name: 'ConcreteProportion',
          component: () => import('@/pages/standing-book/concrete-proportion'),
        },
        {
          path: 'ReportFormManage',
          name: 'ReportFormManage',
          component: () => import('@/pages/report-form/report-form-manage'),
        },
        {
          path: 'MaterialDictionaryManage',
          name: 'MaterialDictionaryManage',
          component: () => import('@/pages/dictionary/material-dictionary-manage'),
        },
        {
          path: 'ConcreteLabelDictionary',
          name: 'ConcreteLabelDictionary',
          component: () => import('@/pages/standing-book/concrete-label-dictionary'),
        },
        // {
        //   path: 'EquipmentBoard',
        //   name: 'EquipmentBoard',
        //   component: () => import(''),
        //   meta: {keepAlive: true}  //是否启用整页缓存（切换页面时，不会重新渲染该页面）
        // }
        {
          path: 'ContractManage',
          name: 'ContractManage',
          component: () => import('@/pages/contract/contract-manage'),
        },

      ]
    },
    {
      path: "/NotFound",
      name: "NotFound",
      component: () => import('@/pages/404'),
      meta: {
        requireAuth: false,//不需要做登录状态验证
      }
    },
    //最后一条路由表，所有路由路径匹配都不通过时，则重定向到404
    {
      path: '*',
      redirect: '/NotFound',//重定向到404
      meta: {
        requireAuth: false,//不需要做登录状态验证
      }
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js